export function formatVoiceProvider(value: string | null | undefined): string {
  if (value === undefined) return 'Not available';
  if (value === 'vapi') return 'VAPI';
  if (value === 'elevenlabs') return 'ElevenLabs';
  return 'Unknown';
}
